import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import type { IntegrationService } from './integration-service';

export interface IntegrationConfig<
  TService extends IntegrationService = IntegrationService,
  TConfigSchema extends z.ZodType<object> = z.ZodType<object>,
> {
  readonly ['_']: {
    ConnectorConfig: TService['_']['ConnectorConfig'];
    Config: z.infer<TConfigSchema>;
  };

  readonly service: TService;
  readonly name: Integration_Handler_Names_Enum;
  readonly configSchema: TConfigSchema;
}

export function make<TService extends IntegrationService, TConfigSchema extends z.ZodType<object>>(
  value: Omit<IntegrationConfig<TService, TConfigSchema>, '_'>,
) {
  return value as IntegrationConfig<TService, TConfigSchema>;
}
